import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocDisplayType, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const sharedProps = {
	feature: HubFeature.BulkCandidateTools,
	htmlAllowed: false,
	shared: true,
	portal: 'SP' as LocPortal,
};

export type BulkAuthorizationErrorsLocs =
	| 'SPBulkAuthCandidateIdNotFound'
	| 'SPBulkAuthExamCodeNotFound'
	| 'SPBulkAuthCandidateAuthorized'
	| 'SPBulkAuthExamCodeNotConfigured'
	| 'SPBulkAuthGrantFailure'
	| 'SPBulkAuthPersistFailure'
	| 'SPBulkAuthDemographicValidationFailure'
	| 'SPBulkAuthRowFailure';

export const spBulkAuthorizationErrorsLocs: LocDefs<BulkAuthorizationErrorsLocs> = {
	SPBulkAuthCandidateIdNotFound: {
		defaultValue: 'Candidate ID not found',
		displayPath: `System|Error|Bulk Authorization|Candidate ID Not Found`,
		description: 'Error shown when the candidate ID is not found.',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
	SPBulkAuthExamCodeNotFound: {
		defaultValue: 'Exam code not found',
		displayPath: `System|Error|Bulk Authorization|Exam Code Not Found`,
		description: 'Error shown when the exam code is not found.',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
	SPBulkAuthCandidateAuthorized: {
		defaultValue: 'Candidate already has authorization for this exam code',
		displayPath: `System|Error|Bulk Authorization|Candidate Already Authorized`,
		description: 'Error shown when the candidate already has authorization for the exam code.',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
	SPBulkAuthExamCodeNotConfigured: {
		defaultValue: 'Exam code not configured for authorizations',
		displayPath: `System|Error|Bulk Authorization|Exam Code Not Configured`,
		description: 'Error shown when the exam code is not configured for authorizations.',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
	SPBulkAuthGrantFailure: {
		defaultValue: 'Failure to grant authorization',
		displayPath: `System|Error|Bulk Authorization|Grant Failure`,
		description: 'Error shown when the grant fails.',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
	SPBulkAuthPersistFailure: {
		defaultValue: 'Failure to complete authorization ',
		displayPath: `System|Error|Bulk Authorization|Persist Failure`,
		description: 'Error shown when the authorization fails to complete.',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
	SPBulkAuthDemographicValidationFailure: {
		defaultValue: 'Failure to complete authorization (demographic info missing)',
		displayPath: `System|Error|Bulk Authorization|Demographic Validation Failure`,
		description:
			'Error shown when the authorization fails to complete due to missing demographic info.',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
	SPBulkAuthRowFailure: {
		defaultValue:
			'Row not processed due to file failure - upload again with other errors corrected',
		displayPath: `System|Error|Bulk Authorization|Row Failure`,
		description:
			'Not fully processed (the process stopped early because one or more other rows failed)',
		displayType: 'Error' as LocDisplayType,
		...sharedProps,
	},
};

export type BulkAuthorizationErrorsLocType = LocMap<BulkAuthorizationErrorsLocs>;

export const BULK_AUTHORIZATION_ERROR_LOCS = MapLocKeys<BulkAuthorizationErrorsLocs>({
	...spBulkAuthorizationErrorsLocs,
});

export const spBulkAuthKeyMap = {
	d73bc825c0c54215a0156898627f0927: BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthCandidateIdNotFound,
	'44a9738f0a544bfea70f910e51b4e634': BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthExamCodeNotFound,
	'698f020341484379a11597d60ff3ea62': BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthCandidateAuthorized,
	'51bd274bf01842d0ac38b0f928dbfa23':
		BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthExamCodeNotConfigured,
	'7ee26e409a234b128605385bce5a361f': BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthGrantFailure,
	'122aa85992bc4b59b2ec7f23fb43ee0d': BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthPersistFailure,
	'6cb2151c1a9f4a7b9b85c7fe65a94e5e':
		BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthDemographicValidationFailure,
	'06c2b74622a7435ba7214ab054437e12': BULK_AUTHORIZATION_ERROR_LOCS.SPBulkAuthRowFailure,
};
